import { TabidooTablePage } from '@/components/vyroba/TabidooTablePage';

/**
 * Chybovost švadlen — zrcadlo Tabidoo tabulky „chybovostSvadlen". Jeden řádek
 * = zjištěná chyba (datum, švadlenka, počet vadných kusů). Z těchhle záznamů
 * se ve výkazu práce počítá počet chyb i chybovost.
 */
export function ChybovostSvadlenPage() {
  return (
    <TabidooTablePage
      table="chybovost"
      storagePrefix="chybovost"
      title="Chybovost švadlen"
      subtitle="Evidence vadných kusů. Zapsané chyby se v měsíčním výkazu sečtou automaticky. Klikni na řádek pro detail a editaci."
      createLabel="Nová chyba"
      defaultSort={{ key: 'datum', dir: 'desc' }}
    />
  );
}
